import PropTypes from 'prop-types';
import get from 'lodash/get';
import ContainerTitle from '../shared/ContainerTitle';
import WideTextTile from '../childPresentations/WideTextTile';
import Tile from '../gallery/childPresentations/Tile';
import Default from '../list/childPresentations/Default';
import containerItemsCss from '../container-items.module.scss';

const layoutMap = {
  WideTextTile,
  SquareTile: Tile,
};

function getComponent(layout) {
  return layoutMap[layout] || Default;
}

const Matrix = ({ containerItem, id, getStyles, onItemClick }) => {
  const children = get(containerItem, 'children', []);
  return (
    <div
      id={id}
      data-testid={id}
      data-testtype="matrixLayout"
      data-testcount={children.length}
    >
      <ContainerTitle
        containerItem={containerItem}
        getStyles={getStyles}
        className={containerItemsCss.contentSubHeader}
      />
      <div data-testid="containerGuideItemsContainer">
        {children.map((child, i) => {
          const layout = get(child, 'presentation.layout');
          const Item = getComponent(layout);
          return (
            <Item
              getStyles={getStyles}
              guideItem={child}
              index={i}
              key={`item-${i}`}
              onClick={onItemClick}
              isMatrix
            />
          );
        })}
      </div>
    </div>
  );
};

Matrix.propTypes = {
  containerItem: PropTypes.object.isRequired,
  selectedContentId: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  getStyles: PropTypes.func.isRequired,
  onItemClick: PropTypes.func.isRequired,
};

export default Matrix;
